define('RecipesAndEvents.ProductDetails.Full.View', [
    'ProductDetails.Full.View',
    'RecipesAndEvents.Ingredients.View',
    'SC.Configuration',
    'article_details.tpl',
    'landing_details.tpl',
    'product_details_full.tpl',
    'underscore'
], function RecipesAndEventsProductDetailsFullView(
    ProductDetailsFullView,
    RecipesIngredientView,
    Configuration,
    articleDetailsTpl,
    landingDetailsTpl,
    productDetailsFullTpl,
    _
) {
    'use strict';


    _.extend(ProductDetailsFullView.prototype, {
        childViews: _.extend(ProductDetailsFullView.prototype.childViews, {
            'IngredientsView': function IngredientsView() {
                return new RecipesIngredientView({
                    id: this.model.get('internalid'),
                    application: this.application,
                    model: this.model
                });
            }
        }),
        getMainImageUrl: function getMainImageUrl(images) {
            var mainImages = _.filter(images, function filter(img) {
                return img.url && img.url.indexOf('Main') >= 0;
            });
            if (mainImages && mainImages.length) {
                return _.first(mainImages).url;
            }
            return '';
        },
        getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function getContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var itemType = this.model.get('item').get('custitem_item_type');
            var itemNetsuiteType = this.model.get('item').get('itemtype');
            var recipesAndEventsTypesExcluded = Configuration.get('recipesAndEvents.typesExcluded') || [];
            var recipesAndEventsfields = Configuration.get('recipesAndEvents.fields') || [];
            if (itemNetsuiteType === 'NonInvtPart' && recipesAndEventsTypesExcluded.indexOf(itemType) < 0) {
                switch (itemType) {
                case 'Events':
                    this.template = articleDetailsTpl;
                    _.each(recipesAndEventsfields, function eachFields(data) {
                        originalContext[data] = this.model.get('item').get(data) || '';
                    }, this);
                    break;
                case 'Recipe':
                    this.template = landingDetailsTpl;
                    // originalContext.main_image = this.model.get('item').get('_images')[1] ? this.model.get('item').get('_images')[1].url : '';
                    originalContext.main_image = this.getMainImageUrl(this.model.get('item').get('_images'));
                    originalContext.title_1 = this.model.get('item').get('custitem_aws_title_box_1');
                    originalContext.title_2 = this.model.get('item').get('custitem_aws_title_box_2');
                    originalContext.details_box_1 = this.model.get('item').get('custitem_aws_details_box_1');
                    originalContext.details_box_2 = this.model.get('item').get('custitem_aws_details_box_2');
                    originalContext.time_required = this.model.get('item').get('custitem_aws_time_required_1');
                    originalContext.name = this.model.get('item').get('_name');
                    originalContext.description = this.model.get('item').get('featureddescription');
                    break;
                default:
                    this.template = productDetailsFullTpl;
                    break;
                }
            }
            // this.model.setItemAttributes(originalContext);
            originalContext.canonicalUrl = this.getCanonical();

            // this.filterOptionsToDisplay(originalContext);
            originalContext.showReviews = originalContext.showReviews && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled;
            return originalContext;
        })
    });
});
